import { Backdrop, Spacer, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import PendingInvites from 'components/layout/header/workspace-selector/pendingInvites';
import WorkspaceList from 'components/layout/header/workspace-selector/workspaceList';
import WorkspaceLogo from 'components/workspace-logo';

import styles from './styles.module.less';

const SelectWorkspaceModal = () => {
  const showSelectWorkspaceModal = useSelector(
    state => state.workspace.showSelectWorkspaceModal
  );
  const selectedWorkspace = useGetSelectedWorkspace();

  return (
    <Backdrop isOpen={showSelectWorkspaceModal}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <WorkspaceLogo workspace={selectedWorkspace} size="large" />
            <Spacer top="large" bottom="large">
              <Text variant="mainTitle">
                You&apos;ve been removed from
                <br />
                {selectedWorkspace.name}
              </Text>
            </Spacer>
            <Spacer bottom="large">
              <Text>Choose another Workspace</Text>
            </Spacer>
          </div>

          <WorkspaceList selectedWorkspace={selectedWorkspace} />

          <PendingInvites />
        </div>
      </div>
    </Backdrop>
  );
};

export default SelectWorkspaceModal;
